// extracted by mini-css-extract-plugin
module.exports = {"article-wrapper":"FixedPage_article-wrapper__Ok7MP"};